import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Doctors } from "./components/doctors";
import { Family } from "./components/family";
import { Cabine } from "./components/cabine";
import { Business } from "./components/business";
import { Howworks } from "./components/howworks";
import { Inovation } from "./components/inovation";
import { Leitor } from "./components/leitor";
import { Remoto } from "./components/remoto";
import { Totem } from "./components/totem";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Testimonials data={landingPageData.Testimonials} />
      <Doctors data={landingPageData.Doctors} />
      <Family data={landingPageData.Family} />
      <Inovation data={landingPageData.Inovation} />
      <Remoto data={landingPageData.Remoto} />
      <Totem data={landingPageData.Totem} />
      <Cabine data={landingPageData.Cabine} />
      <Leitor data={landingPageData.Leitor} />
      <Business data={landingPageData.Business} />
      
    </div>
  );
};

export default App;
